import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string).catch((error) => {
      // Allow retry after transient load failures (network, blocked script).
      stripePromise = null;
      throw error;
    });
  }

  return stripePromise;
};

export const resetStripe = () => {
  stripePromise = null;
};
